import Vue from 'vue'
import CA, { reactive, watch } from '@vue/composition-api'
Vue.use(CA)

const user = reactive({
  token: null,
  id: null,
  hasToBeReady: false,
  isReady: false,
  isNewUser: false
})

export default user
